import { buildAxiosInstance, buildMakeUseAxios } from "@root/api/api.tools";

const DIAGNOSIS_BASE_URL = `${import.meta.env.VITE_CANDIDATE_SERVICE_URL}/diagnoses`;
export const diagnosisAxiosInstance = buildAxiosInstance(DIAGNOSIS_BASE_URL);
export const useAxiosDiagnosis = buildMakeUseAxios(DIAGNOSIS_BASE_URL);
